import React, { useState, useEffect } from 'react';
import { useHorariosLazyQuery } from '../graphql/queries/horarios.query';
import { HorariosPageQuery_horarios } from '../graphql/queries/__generated__/HorariosPageQuery';
import { useCadastrarHorarioMutation } from '../graphql/mutations/cadastrar_horario.mutation';
import { useDeletarHorarioMutation } from '../graphql/mutations/deletar_horario.mutation';
import { useEditarHorarioMutation } from '../graphql/mutations/editar_horario.mutation';
import { FormHorario, FormularioHorario } from '../components/form_horario';
import { FormList } from '../../shared/components/form_components/list';
import { Container } from '../../shared/components/layout_components/container/styles';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';

const HorarioPage: React.FC = () => {
  const [horario, setHorario] = useState<FormHorario>();
  const [horarios, setHorarios] = useState<HorariosPageQuery_horarios[]>([]);
  const itens_por_pagina = 25;

  const [obter_horarios, { fetchMore, loading }] = useHorariosLazyQuery();
  const [cadastar_horario] = useCadastrarHorarioMutation();
  const [editar_horario] = useEditarHorarioMutation();
  const [deletar_horario] = useDeletarHorarioMutation();

  const on_submit = async (horario: FormHorario) => {
    if (!horario.id_horario) {
      const { data } = await cadastar_horario({
        variables: {
          ...horario,
        },
      });

      if (data) {
        setHorarios([...horarios, data.cadastrarHorario]);

        alert('Horário cadastrado com sucesso!');
      }
    } else {
      const { data } = await editar_horario({
        variables: {
          ...horario,
          id_horario: horario.id_horario,
        },
      });

      if (data) {
        const index = horarios.findIndex((item) => item.id_horario === horario.id_horario);

        if (index !== -1) {
          const horarios_atualizados = [...horarios];
          horarios_atualizados[index] = data.editarHorario;
          setHorarios(horarios_atualizados);
        }

        alert('Horário editado com sucesso!');
      }
    }

    setHorario(undefined);
  };

  const on_edit = (horario: HorariosPageQuery_horarios) => {
    setHorario({
      id_horario: horario.id_horario,
      hora_inicio: horario.hora_inicio,
      hora_fim: horario.hora_fim,
    });
  };

  const on_delete = async (id_horario: number) => {
    await deletar_horario({ variables: { id_horario } });
    setHorarios((horarios) => horarios.filter((h) => h.id_horario !== id_horario));
  };

  const on_cancel_edit = () => {
    setHorario(undefined);
  };

  const on_search = async (search: string) => {
    const { data } = await fetchMore({
      variables: {
        descricao: search,
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setHorarios(data.horarios);
    }
  };

  const dados_dados_iniciais = async () => {
    const { data } = await obter_horarios({
      variables: {
        descricao: '',
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setHorarios(data.horarios);
    }
  };

  useEffect(() => {
    document.title = 'SisIEC - Horários';
    dados_dados_iniciais();
  }, []);

  return (
    <Container>
      <SubContainer flex={1}>
        <FormularioHorario onSubmit={on_submit} onCancel={on_cancel_edit} horario={horario} />
      </SubContainer>

      <SubContainer flex={2}>
        <FormList
          list_name='Horários'
          items={horarios.map((h) => ({
            data: h,
            id: h.id_horario,
            label: h.hora_inicio + ' - ' + h.hora_fim,
          }))}
          onSearch={on_search}
          onEdit={on_edit}
          onDelete={on_delete}
          loading={loading}
        />
      </SubContainer>
    </Container>
  );
};

export { HorarioPage };
